export enum FileTypes {
  BMP = 'image/bmp',
  MSWORD = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  GIF = 'image/gif',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PDF = 'application/pdf',
  PNG = 'image/png',
  RTF = 'text/rtf',
  TIFF = 'image/tiff',
  TXT = 'text/plain',
  MSEXCEL = 'application/msexcel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}
